import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { doc, getDoc } from "firebase/firestore";
import db from "../../config/firebase";
import { Category } from "../../models/category";

export const fetchCategories = createAsyncThunk(
  "categories/fetchAll",
  async () => {
    const categoryDoc = doc(db, "admin/categories");
    const snapshot = await getDoc(categoryDoc);
    if (snapshot.exists()) {
      const data = snapshot.data();
      return (data.categories || []) as Category[];
    } else {
      throw new Error("Category document not found");
    }
  }
);

export const fetchSubCategories = createAsyncThunk(
  "subcategories/fetchAll",
  async () => {
    const subcategoryDoc = doc(db, "admin/subcategories");
    const snapshot = await getDoc(subcategoryDoc);
    if (snapshot.exists() ) {
      const data = snapshot.data();
      
      return (data.categories || []) as Category[];
    } else {
      throw new Error("SubCategory document not found");
    }
  }
);

const categorySlice = createSlice({
  name: "categories",
  initialState: {
    items: [] as Category[],
    subcategories: [] as Category[],
    loading: false,
    error: null as string | null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch categories";
      })
      .addCase(fetchSubCategories.pending, (state) => {
      })
      .addCase(fetchSubCategories.fulfilled, (state, action) => {
        state.subcategories = action.payload;
        state.error = null;
      })
      .addCase(fetchSubCategories.rejected, (state, action) => {
        state.error = action.error.message || "Failed to fetch subcategories";
      });
  },
});

export default categorySlice.reducer;
